const CareManagerRoles: { value: string; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'doctor', label: 'Physician' },
  { value: 'physicianAssistant', label: 'Physician Assistant' },
  { value: 'nursePractitioner', label: 'Nurse Practitioner' },
  { value: 'medicalAssistant', label: 'Medical Assistant' },
  { value: 'QHCP', label: 'QHCP' },
  { value: 'registeredNurse', label: 'Registered Nurse' },
];

export default CareManagerRoles;
